import { Reveal } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "REGISTER + GET YOUR BASELINE",
    body: "Join free. Complete your assessments, weight, measurements + photos.",
  },
  {
    n: "02",
    title: "PREP + GET YOUR PLAN",
    body: "Order supplements. Grocery list drops first. Full menu unlocks 3 days before Day 1.",
  },
  {
    n: "03",
    title: "GIVE ME 14 DAYS",
    body: "Eat. Supplement. Walk. Hydrate. Restorative yoga. Sleep. Recover. Lose 2-10 pounds, Reset your metabolism and CNS",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-[#FFFFFF] px-4 sm:px-8 lg:px-12 py-14 sm:py-20 lg:py-28">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.25em] text-[#1B2FD8]">The Process</p>
          <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl text-[#0B0B12] mt-4">
            HOW IT WORKS
          </h2>
        </Reveal>
        <div className="mt-10 sm:mt-14 grid md:grid-cols-3 gap-4 sm:gap-6">
          {STEPS.map((step, i) => (
            <Reveal key={step.n} delay={i * 0.12} className="h-full">
              <div data-testid={`how-it-works-step-${i}`} className="relative h-full rounded-3xl border border-[#E3E3F0] bg-[#F3F3FA] p-6 sm:p-8 sm:pt-10 overflow-hidden hover:-translate-y-1.5 hover:shadow-xl hover:shadow-[#1B2FD8]/10 transition-all duration-300">
                <span className="font-display font-extrabold text-7xl text-[#E3E3F0] absolute -top-3 right-4 select-none">{step.n}</span>
                <p className="font-display font-bold text-[#1B2FD8] tracking-[0.25em] text-sm">{step.n}</p>
                <h3 className="font-display font-bold text-xl sm:text-2xl text-[#0B0B12] mt-3 tracking-tight relative">{step.title}</h3>
                <p className="text-[#4A4A66] leading-relaxed mt-4 text-sm sm:text-base relative">{step.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
